module.exports = __webpack_public_path__ + "static/council-of-metallic-dragons-e3af70908cccebe52dffe94e80a8c0a6.webp";